import { Button, Form, Input, InputNumber, message, Modal } from "antd";
import { useState } from "react";
import { validateNonNegativeNumber } from "../helpers/common";
import ForwarderService from "../services/Forwarder/ForwarderService";

const NewForwarder = ({ visible, onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const onFinish = (values) => {
    setLoading(true);

    ForwarderService.createForwarder(values)
      .then((response) => {
        message.success("Forwarder saved successfully!");
        form.resetFields();
        onSuccess?.();
        onClose();
      })
      .catch((error) => {
        console.error(error);
        message.error("Error saving forwarder.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title="Add Forwarder"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{
          DetentionFreeDays: 0,
          DetentionDailyFee: 0,
        }}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
          <Form.Item
            name="CompanyName"
            label="Company Name"
            rules={[{ required: true, message: "Required" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item name="CompanyShortName" label="Company Short Name">
            <Input />
          </Form.Item>

          <Form.Item name="ContactName" label="Contact Name">
            <Input />
          </Form.Item>

          <Form.Item
            name="Email"
            label="Email"
            rules={[{ type: "email", message: "Invalid email" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Free Days"
            name="DetentionFreeDays"
            rules={[{ validator: validateNonNegativeNumber(false) }]}
          >
            <InputNumber
              controls={false}
              placeholder="Days"
              size="large"
              className="w-full"
              min={0}
              onKeyDown={(e) => {
                const allowedKeys = [
                  "Backspace",
                  "Delete",
                  "ArrowLeft",
                  "ArrowRight",
                  "Tab",
                  "Home",
                  "End",
                ];
                const isNumberKey = e.key >= "0" && e.key <= "9";
                const isAllowed = isNumberKey || allowedKeys.includes(e.key);

                if (!isAllowed) {
                  e.preventDefault();
                }
              }}
            />
          </Form.Item>

          <Form.Item
            label="Daily Fee"
            name="DetentionDailyFee"
            rules={[{ validator: validateNonNegativeNumber(true) }]}
          >
            <InputNumber
              controls={false}
              placeholder="Fee"
              size="large"
              className="w-full"
              min={0}
              precision={2}
              onKeyDown={(e) => {
                const allowedKeys = [
                  "Backspace",
                  "Delete",
                  "ArrowLeft",
                  "ArrowRight",
                  "Tab",
                  "Home",
                  "End",
                ];
                const isNumberKey = e.key >= "0" && e.key <= "9";
                if (e.key === ".") {
                  if (e.currentTarget.value.includes(".")) {
                    e.preventDefault();
                  }
                  return;
                }

                const isAllowed = isNumberKey || allowedKeys.includes(e.key);

                if (!isAllowed) {
                  e.preventDefault();
                }
              }}
            />
          </Form.Item>
        </div>

        <div className="flex justify-end mt-6 space-x-4">
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            className="bg-[#04C6BD]"
          >
            Save
          </Button>
          <Button
            onClick={handleCancel}
          >
            Close
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default NewForwarder;
